const GenerationTracker = ({ tracker, postID, siteID }) => {
  if (!tracker) return null;
};

export default GenerationTracker;
